class ElderLoaderBackground extends HTMLElement {
  constructor() {
    super();

    const isDarkMode =
      localStorage.getItem("theme.preference") === "elder-dark";
    // Create a shadow root
    this.attachShadow({ mode: "open" });

    // Style and HTML
    this.shadowRoot.innerHTML = `
  <style>
    .loader-background {
      --loader-bg-surface: ${isDarkMode ? "#121212" : "#f2f2f2"};
      --loader-bg-dark-gray: ${isDarkMode ? "#b69f6a" : "#1d1d1b"};
      --loader-bg-dark-blue: ${isDarkMode ? "#b69f6a" : "#002852"};
      position: relative;
      height: 100vh;
      width: 100vw;
      background-color: var(--loader-bg-surface);      
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .title-text {
      color: #BB9F61;
      font-family: Roboto,
      Helvetica,
      sans-serif;
      font-size: 1.5em;
    }

    body {
      margin: 0;
      padding: 0;
    }


    .spinner {
      position: absolute;

      width: 400px;
      text-align: center;
    }

    .logo {
      width: 100px;
      height: 100px;
      display: inline-block;
     -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .circle {
      border: 3px solid var(--loader-bg-dark-blue);
      height: 50px;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
      width: 50px;

      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }

    .spinner .bounce2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
      0%, 80%, 100% {
        -webkit-transform: scale(0)
      }
      40% {
        -webkit-transform: scale(1.0)
      }
    }

    @keyframes sk-bouncedelay {
      0%, 80%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
      }
      40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
      }
    }

  </style>


  <div class="loader-background">

    <div class="spinner">
      <div class="bounce1 circle"></div>
      <div class="bounce2 logo">
        <svg id="a" data-name="Archie" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <g id="b" data-name="shape">
                <path d="M50,45.863c-1.952,3.916-4.426,6.802-7.273,8.833.048,1.125.613,7.438,7.273,11.729,6.597-4.293,7.214-10.61,7.271-11.73-2.845-2.03-5.319-4.916-7.271-8.832Z" fill="var(--loader-bg-dark-gray)"/>
            </g>
            <circle id="c" data-name="shape" cx="69.085" cy="35.615" r="6.7" fill="var(--loader-bg-dark-gray)"/>
            <g id="d" data-name="shape">
                <path d="M100,7.127s-14.2,6.057-29.854,6.057c-10.649,0-18.237,3.388-18.237,11.875,0,3.563-.057,7.226.097,9.472.715,10.446,6.798,20.257,22.042,20.257,15.009,0,14.928-16.463,14.865-20.257-.196-11.737.429-15.127,11.088-27.404ZM70.459,47.93c-7.4,0-13.399-5.999-13.399-13.399s5.999-13.399,13.399-13.399,13.399,5.999,13.399,13.399-5.999,13.399-13.399,13.399Z" fill="var(--loader-bg-dark-blue)"/>
            </g>
            <circle id="e" data-name="shape" cx="30.91" cy="35.902" r="6.7" fill="var(--loader-bg-dark-gray)"/>
            <g id="f" data-name="shape">
                <path d="M48.091,25.059c0-8.486-7.588-11.875-18.237-11.875C14.2,13.184,0,7.127,0,7.127c10.659,12.277,11.284,15.666,11.088,27.404-.063,3.795-.145,20.257,14.865,20.257,15.244,0,21.327-9.811,22.042-20.257.154-2.245.097-5.909.097-9.472ZM29.541,47.93c-7.4,0-13.399-5.999-13.399-13.399s5.999-13.399,13.399-13.399,13.399,5.999,13.399,13.399-5.999,13.399-13.399,13.399Z" fill="var(--loader-bg-dark-blue)"/>
            </g>
            <g id="g" data-name="shape">
                <path d="M34.305,8.585c4.795-2.473,10.144-3.785,15.695-3.785s10.899,1.312,15.695,3.785l8.333-.331C67.398,3.082,59.059,0,50,0s-17.398,3.082-24.028,8.254l8.333.331Z" fill="var(--loader-bg-dark-blue)"/>
            </g>
        </svg>
      </div>
      <div class="bounce3 circle"></div>
    </div>

  </div>

    `;
  }
}

customElements.define("elder-loader-background", ElderLoaderBackground);
